import React from "react";
import { ReactComponent as MarkerPinIcon } from "../../assets/icons/marker-pin-03.svg";
import { ReactComponent as RowsIcon } from "../../assets/icons/rows-03.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar-blank.svg";

// This component handles the tab navigation for the Asset Dashboard. it toggles between "Insights" and "Asset Map" views.

// Props type definition
type AssetDashboardTabsProps = {
  activeTab: "insights" | "map";
  onTabChange: (next: "insights" | "map") => void;
};
// AssetDashboardTabs Component
const AssetDashboardTabs = ({ activeTab, onTabChange }: AssetDashboardTabsProps) => {
  return (
    // Container for tabs and date selector
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
        {/* Insights Tab */}
        <button
          type="button"
          className={`inline-flex w-full items-center justify-center gap-3 px-4 py-2 text-[15px] sm:w-auto sm:min-w-[220px] -mb-[2px] ${
            activeTab === "insights"
              ? "rounded-t-[12px] border-b-2 border-[#8EA63C] bg-lime-50 font-medium text-slate-900"
              : "rounded-[8px] border border-transparent bg-white text-eai-dark"
          }`}
          onClick={() => onTabChange("insights")}
        >
          <RowsIcon className="h-3 w-3" />
          Insights
        </button>
        {/* Asset Map Tab */}
        <button
          type="button"
          className={`inline-flex w-full items-center justify-center gap-3 px-4 py-2 text-[15px] sm:w-auto sm:min-w-[220px] -mb-[2px] ${
            activeTab === "map"
              ? "rounded-t-[12px] border-b-2 border-[#8EA63C] bg-lime-50 font-medium text-slate-900"
              : "rounded-[8px] border border-transparent bg-white text-eai-dark"
          }`}
          onClick={() => onTabChange("map")}
        >
          <MarkerPinIcon className="h-3 w-3" />
          Asset Map
        </button>
      </div>
      {/* Date Range Selector */}
      <button
        type="button"
        className="inline-flex h-9 w-full items-center justify-center gap-3 rounded-[8px] border border-eai-bg-lt2 bg-white px-3 text-[14px] text-eai-dark sm:w-auto"
      >
        Jan 2025 - Dec 2025
        <CalendarIcon className="h-3 w-3" />
      </button>
    </div>
  );
};

export default AssetDashboardTabs;
